
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blade-robotic-lawn-mower",
      function () {
        return require("private-next-pages/blade-robotic-lawn-mower/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blade-robotic-lawn-mower"])
      });
    }
  